import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Onewaycabservice() {



const cardData = {
  keyword: " One Way Cab Service",

headingDescription:
  "Omshree Cab offers reliable and affordable one way cab service in Mumbai for travelers looking for convenient and hassle-free transportation without the need for a return journey. Whether you need a cab for airport transfers, business travel, city rides, or outstation trips, our one way cab service ensures a smooth and comfortable experience with professional drivers and well-maintained vehicles. We provide flexible booking options with transparent per-kilometer pricing so you only pay for the distance you travel. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickup from any location in Mumbai and 24/7 customer support, Omshree Cab is your trusted partner for dependable and cost-effective one way cab services.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of the most famous landmarks in Mumbai and a major attraction for tourists visiting the city. Located near the waterfront in South Mumbai, this historic monument was built during the British era and offers stunning views of the Arabian Sea. Visitors come here to admire the grand architecture, take photographs, and enjoy boat rides to Elephanta Island. The surrounding area of Colaba is filled with cafes, street vendors, and historic buildings. Using a one way cab service makes it easy for travelers to reach the Gateway of India comfortably without worrying about traffic or parking in the busy tourist district."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a beautiful coastal road that runs along the Arabian Sea and is popularly known as the Queen’s Necklace because of the sparkling lights visible at night. The long promenade attracts locals and tourists who come here for evening walks, sunset views, and relaxation by the sea. The cool sea breeze and wide open view of the ocean make it one of the most peaceful spots in the city. A one way taxi ride allows travelers to enjoy a scenic drive along this iconic stretch while conveniently reaching nearby attractions in South Mumbai."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of the most popular beaches in Mumbai and a favorite destination for families and tourists. Visitors come here to relax on the sandy shore, enjoy the sea breeze, and taste famous Mumbai street foods like pav bhaji, bhel puri, and pani puri. The beach becomes lively in the evening when people gather to watch the sunset and spend time with friends and family. Booking a one way cab makes traveling to Juhu Beach easy and comfortable, especially during busy weekends when public transport can be crowded."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is one of the most important religious places in Mumbai dedicated to Lord Ganesha. Devotees from across India visit the temple to seek blessings and pray for prosperity and success. The temple is known for its peaceful spiritual atmosphere and beautiful architecture. It becomes especially crowded during Ganesh Chaturthi and other religious occasions. A one way cab service allows devotees and tourists to travel comfortably to the temple without worrying about parking or navigating through busy city traffic."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is a modern cable-stayed bridge that connects Bandra and Worli across the Arabian Sea. It is one of Mumbai’s most impressive infrastructure projects and offers breathtaking views of the sea and city skyline. Driving across the bridge provides a memorable experience, especially during sunset or at night when the lights create a beautiful atmosphere. Many travelers enjoy taking a one way taxi ride across the sea link while exploring the western suburbs and South Mumbai."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous Islamic shrine located on a small island off the coast of Mumbai. The white marble structure stands beautifully in the middle of the sea and is connected to the mainland by a narrow walkway that becomes visible during low tide. Visitors from different religions come here to pray and experience the calm spiritual environment. The surrounding sea views make it one of the most unique landmarks in Mumbai. A one way cab ride provides convenient travel to this sacred site."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock-cut caves located on Elephanta Island in Mumbai Harbour and are known for their magnificent sculptures dedicated to Lord Shiva. The caves are a UNESCO World Heritage Site and attract visitors interested in history, culture, and architecture. Tourists usually take a ferry from the Gateway of India to reach the island and explore the cave temples. Booking a one way taxi makes it convenient to reach the ferry point and start the journey to this historic destination."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large forest reserve located within Mumbai city and provides a refreshing escape from the busy urban environment. The park is known for its lush greenery, wildlife, and ancient Kanheri Caves carved into rock by Buddhist monks centuries ago. Visitors enjoy trekking, cycling, nature walks, and exploring the historical caves. A one way cab service allows travelers to reach the park easily and enjoy a relaxing day surrounded by nature."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is one of the most vibrant shopping streets in Mumbai and is famous for its lively street markets. Visitors can shop for clothing, jewelry, handicrafts, accessories, and souvenirs while enjoying the bustling atmosphere. The area also features many cafes and restaurants where tourists can relax and experience the local culture. Taking a one way taxi to Colaba Causeway allows visitors to explore the market comfortably without worrying about parking or crowded public transport."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped terraced gardens located on Malabar Hill. The gardens provide stunning views of Marine Drive and the Arabian Sea. Visitors enjoy peaceful walks among the greenery, photography, and relaxing in the calm environment away from the city noise. A one way cab service makes it easy to reach this scenic location and combine it with nearby attractions in South Mumbai."
  }
],




services: [
{
name: "One Way Cab Service",
description: "One way cab service offers convenient and affordable transportation for passengers traveling to their destination without paying for return charges. This service is ideal for intercity travel, airport transfers, and long-distance journeys. Our fleet includes comfortable AC sedans, SUVs, and premium vehicles suitable for highway travel. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, and airports. Spacious interiors ensure comfortable seating during the journey. Flexible travel schedules allow passengers to plan trips easily. Transparent pricing ensures no hidden costs. Reliable one way cab services provide smooth and economical travel experiences."
},
{
name: "One Way Taxi Service",
description: "One way taxi service provides reliable transportation for passengers traveling between cities or destinations without requiring a return trip booking. Our AC vehicles ensure comfortable highway travel and smooth driving experience. Professional drivers ensure safe driving and punctual arrival at your destination. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for business travel, tourism visits, and personal trips. Spacious seating ensures relaxed journeys during long-distance travel. Flexible scheduling allows passengers to choose convenient departure times. Reliable taxi services ensure safe and affordable one way travel."
},
{
name: "One Way Cab Booking",
description: "One way cab booking allows passengers to reserve vehicles easily for single-trip journeys between cities. Our fleet includes AC sedans and SUVs designed for comfortable travel on highways and city roads. Professional drivers ensure punctual pickup and safe driving throughout the journey. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for airport transfers, intercity travel, and tourism trips. Spacious interiors ensure comfortable seating during travel. Flexible booking options allow passengers to schedule rides easily. Reliable cab booking services ensure smooth one way transportation."
},
{
name: "One Way Taxi Booking Online",
description: "One way taxi booking online provides quick and convenient digital reservations for passengers planning intercity travel. Online booking systems offer instant confirmation and easy ride scheduling. Comfortable AC vehicles ensure smooth travel across highways and city routes. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across residential areas, hotels, offices, and airports. Ideal for tourists, business travelers, and daily commuters. Spacious seating ensures comfortable journeys. Reliable online taxi booking ensures hassle-free one way travel."
},
{
name: "Cheap One Way Cab Service",
description: "Cheap one way cab service offers affordable transportation for passengers seeking budget-friendly intercity travel. Our fleet includes economical AC sedans and compact cars suitable for comfortable journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across homes, hotels, offices, and transport hubs. Ideal for students, daily commuters, and budget travelers. Comfortable interiors ensure relaxed travel during the trip. Flexible booking options allow convenient ride scheduling. Affordable pricing ensures economical one way travel without compromising safety."
},
{
name: "Outstation One Way Cab",
description: "Outstation one way cab service offers reliable transportation for passengers traveling to destinations outside the city. Our fleet includes AC sedans, SUVs, and premium vehicles suitable for long-distance highway journeys. Professional drivers ensure safe driving and punctual arrival at destinations. Pickup services are available from homes, hotels, offices, and airport terminals. Ideal for family trips, tourism travel, and business visits. Spacious interiors ensure comfortable seating during long journeys. Flexible one way booking options help passengers reduce travel costs. Reliable outstation cab services ensure smooth travel experiences."
},
{
name: "One Way Airport Cab Service",
description: "One way airport cab service provides convenient transportation for passengers traveling to or from airports without return charges. Our AC vehicles ensure comfortable travel between airport terminals and city destinations. Professional drivers monitor flight schedules to ensure punctual pickup and drop services. Pickup services are available from homes, hotels, offices, and airport terminals. Ideal for business travelers, tourists, and families. Spacious seating ensures comfortable airport transfers. Flexible booking options allow advance ride reservations. Reliable airport cab services ensure stress-free travel."
},
{
name: "One Way Intercity Taxi Service",
description: "One way intercity taxi service provides comfortable transportation for passengers traveling between cities. Our AC sedans and SUVs ensure smooth highway travel and relaxed journeys. Professional drivers ensure safe driving and timely arrival at destinations. Pickup services are available from homes, hotels, offices, and airports across cities. Ideal for business travel, tourism visits, and family trips. Spacious seating ensures comfortable long-distance journeys. Flexible travel schedules allow passengers to plan trips easily. Reliable intercity taxi services ensure smooth and safe travel."
},
{
name: "One Way Cab Near Me",
description: "One way cab near me helps passengers quickly find nearby cab services for single-trip travel. Our fleet includes comfortable AC vehicles suitable for both city and intercity transportation. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, and airports in nearby areas. Ideal for urgent travel, airport transfers, and business trips. Spacious interiors ensure comfortable seating during travel. Flexible booking options allow quick ride scheduling. Reliable cab services ensure convenient travel anytime."
},
{
name: "One Way Cab Price",
description: "One way cab price offers transparent and affordable travel costs for passengers planning intercity trips. Clear pricing helps travelers understand the fare before booking the ride. Our fleet includes sedans, SUVs, and premium vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions. Professional drivers ensure safe driving and punctual arrival at destinations. Pickup services are available across residential and commercial areas. Flexible travel options allow passengers to select suitable vehicles. Transparent pricing ensures economical one way travel."
},
{
name: "One Way Taxi Fare",
description: "One way taxi fare is calculated using clear per kilometer pricing to provide transparent travel costs for passengers. Our AC vehicles ensure comfortable travel across highways and city routes. Professional drivers ensure safe driving and timely arrival at destinations. Pickup services are available from homes, hotels, offices, and airports. Ideal for intercity travel, airport transfers, and tourism visits. Spacious seating ensures comfortable journeys during the trip. Flexible booking options allow passengers to choose convenient travel times. Reliable fare structure ensures affordable taxi services."
},
{
name: "One Way Cab Booking Online",
description: "One way cab booking online provides fast and convenient digital reservations for passengers planning single-trip journeys. Instant confirmation allows passengers to schedule rides easily. Comfortable AC sedans and SUVs ensure smooth highway travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across homes, hotels, offices, and airport terminals. Ideal for business travel, tourism trips, and airport transfers. Spacious interiors ensure comfortable seating during travel. Reliable online cab booking ensures smooth and hassle-free transportation."
}
],

tableData: [
["One Way Cab Service","One Way Taxi Service"],
["One Way Cab Booking","One Way Taxi Booking Online"],
["Cheap One Way Cab Service","Outstation One Way Cab"],
["One Way Airport Cab Service","One Way Intercity Taxi Service"],
["One Way Cab Near Me","One Way Cab Price"],
["One Way Taxi Fare","One Way Cab Booking Online"]
],



whychoose: [
  {
    WhyChooseheading: "Convenient One-Way Travel",
    WhyChoosedescription: "Omshree Cabs provides convenient one-way cab services so travelers can reach their destination without paying for return travel. This makes intercity journeys more affordable and efficient."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "We offer clear and transparent pricing for one-way cab bookings. Customers are informed about per-kilometer charges, toll fees, and travel costs before booking so there are no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our one-way cab service is available 24 hours a day. Whether you need an early morning ride, a late-night journey, or urgent travel, Omshree Cabs is always ready to serve."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible Route Options",
    WhyChoosedescription: "Omshree Cabs provides one-way cab services for multiple destinations including airport transfers, city-to-city travel, and outstation routes based on your travel needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for solo travelers, families, and business travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup",
    WhyChoosedescription: "Our drivers provide doorstep pickup from homes, offices, hotels, railway stations, and airports, making one-way travel simple and convenient."
  },
  {
    WhyChooseheading: "Reliable Intercity Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by travelers for reliable one-way cab services. Our punctual drivers, comfortable vehicles, and professional support ensure a smooth journey."
  }
]
};

const faqData = [
  { question: "What is a one-way cab service?", answer: "A one-way cab service allows passengers to travel from one city to another without paying for the return journey." },
  { question: "Do you provide one-way cab services from Mumbai?", answer: "Yes, Omshree Cabs provides one-way cab services from Mumbai to many destinations including Pune, Nashik, Surat, and more." },
  { question: "Which vehicles are available for one-way travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your travel needs." },
  { question: "Is one-way travel cheaper than round-trip booking?", answer: "Yes, one-way cab services are usually more economical because customers only pay for the distance traveled." },
  { question: "Can I book a one-way cab for airport transfer?", answer: "Yes, our one-way cab service is also available for airport pickups and drops." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Is the service available 24 hours?", answer: "Yes, Omshree Cabs offers 24/7 one-way cab booking services." },
  { question: "Do you provide long-distance one-way travel?", answer: "Yes, we provide long-distance one-way travel between cities for business and personal trips." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking helps ensure vehicle availability, especially during peak travel periods." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Shah",
    feedback:
      "I booked a one-way cab from Mumbai through Omshree Cabs. The service was punctual, affordable, and the ride was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Omshree Cabs provided a great one-way travel experience. Clean car, professional driver, and smooth journey throughout.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Cab Service",
  "description": "Omshree Cab provides reliable One Way Cab Service for local, outstation, and airport travel. Book one-way taxis online easily at affordable fares. Trusted service for intercity travel and instant online cab booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4700"
  }
};




  return (
    <div>
      

<Helmet>
  <title>One Way Cab Service | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers reliable one way cab service for local, outstation, and airport travel. Book one-way taxis online at affordable fares with trusted intercity and airport cab service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onewaycabservice;